import React from 'react'
import Link from 'gatsby-link'
import MobileNavigation from '../components/mobile-navigation'
import './header.scss'
import logo from "./logo.svg";

class Header extends React.Component {
  render() {
    const { footerData, isNavActive } = this.props;
    const mobileNavClass = isNavActive ? 'open' : 'closed';

    return (
      <div className="header">
        <Link id="logo-area" className="logo" to={"/"}><img src={logo} /></Link>

        <div className="mobile-nav-wrapper">
          <button className="toggle-nav open" onClick={this.handleClick.bind(this)}>
            <span>+</span>
          </button>

          <MobileNavigation
            linkData={this.props.linkData}
            toggleMobileNav={this.handleClick.bind(this)}
            mobileNavClass={mobileNavClass} footerData={footerData} />
        </div>
      </div>
    )
  }

  handleClick() {
    this.props.setMobileState();
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js